<template>
  <div>
    <el-row style="margin-top: 20px">
      <el-col>
        <el-table :data="tableData" stripe border>
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <el-table-column label="品名" prop="NAME"></el-table-column>
          <el-table-column label="编号" prop="PRODUCT_CODE"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT"></el-table-column>
          <el-table-column label="单价" prop="PRODUCT_PRICE"></el-table-column>
          <el-table-column label="批次" prop="BATCH"></el-table-column>
          <el-table-column label="调拨数量" prop="PRODUCT_COUNT"></el-table-column>
          <el-table-column label="价值" prop="PRODUCT_WORTH"></el-table-column>
          <el-table-column label="价值（不含税）" prop="PRODUCT_WORTH_BEFORE_TAX"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      tableData: [],
      documentStatus: Number(sessionStorage.getItem('status')),
    };
  },
  methods: {
    queryDetail() {
      const params = {
        SERVICE_ID: '10061',
        OTYPE: 3,
        TRANSFER_ID: Number(this.$route.params.id),
      };
      http.post(params).then((result) => {
        if (result[0]) {
          this.tableData = result;
        } else {
          this.tableData = [];
        }
      });
    },
  },
  created() {
    this.queryDetail();
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/warehouseManage/adjust_enter_detail.vue